<template>
    <div>
        <b-modal id="payment" :title="editing ? 'Ödeme Güncelle':'Ödeme'" no-close-on-esc no-close-on-backdrop>
            <levy-payment v-model="levyPayment" :errors="errors"></levy-payment>
            <template #modal-footer><v-executer :loading="loading" :text="editing ?'Güncelle' :'Öde'" :action="pay"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    pagination="server"
                    name="levy-installment"
                    :buttons="buttons"
                    :settings="false"
                    :fields="fields"></v-table>
    </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'
import moment from 'moment'
import LevyPayment from './LevyPayment.vue'
export default {
    components:{
        LevyPayment
    },
    props:{
        value:Object,
        errors:Object
    },
    data() {
        return {
            editing:true,
            loading:false,
            fields:[
                {name:"Taksit",key:'InstallmentNumber'},
                {name:'Son Ödeme Tarihi',key:'PaymentDate',thClass:'w-20'},
                {name:'Ödeme Tarihi',key:'PaidDate',thClass:'w-20'},
                {name:"Ödenecek Miktar",key:'AmountToPayString',thClass:'w-20'},
                {name:"Ödenen Miktar",key:'PaidAmountString',thClass:'w-20'},
                {name:"Durum",component:true,componentOptions:{name:"levy-payment-status/LevyPaymentStatus"}},
            ],
            buttons:[
                {text:"Öde",key:"payment",icon:"PlusIcon",variant:"success",action:this.payLevy,condition:(item)=>!item.Paid},
                {text:"Ödeme Güncelle",key:"edit",icon:"Edit2Icon",variant:"success",action:this.editLevyPayment,condition:(item)=>item.Paid},
                {text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete,condition:(item)=>item.Paid},
            ],
            levyPayment:{
                Id:null,
                EmployeeLevyId:null,
                PaidAmount:null,
                PaymentDate:null,
                PaidDate:null,
                PaidOnTime:null,
                InstallmentNumber:null,
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.levyPayment.Id = null
            this.levyPayment.EmployeeLevyId = null
            this.levyPayment.PaidAmount = null
            this.levyPayment.PaymentDate = null
            this.levyPayment.PaidDate = null
            this.levyPayment.PaidOnTime = null
            this.levyPayment.InstallmentNumber = null
        },
        provider(data){
            return EmployeeOperationsApi.Levy.Payment.Table(data,this.value.Id)
        },
        editLevyPayment(item){
            this.clearForm()
            this.editing = true
            this.levyPayment.Id = item.Id
            this.levyPayment.EmployeeLevyId = item.EmployeeLevy?.Id || null
            this.levyPayment.PaidAmount = item.PaidAmount
            this.levyPayment.PaymentDate = moment(item.PaymentDate,'DD.MM.YYYY').format('YYYY-MM-DD')
            this.levyPayment.PaidDate = item.PaidDate ? moment(item.PaidDate,'DD.MM.YYYY').format('YYYY-MM-DD') : null
            this.levyPayment.PaidOnTime = item.PaidOnTime
            this.levyPayment.InstallmentNumber = item.InstallmentNumber
            this.$showModal('payment')
        },
        payLevy(item){
            this.clearForm()
            this.levyPayment.Id = item.Id
            this.levyPayment.EmployeeLevyId = item.EmployeeLevy?.Id || null
            this.levyPayment.PaidAmount = item.PaidAmount
            this.levyPayment.PaymentDate = moment(item.PaymentDate,'DD.MM.YYYY').format('YYYY-MM-DD')
            this.levyPayment.PaidDate = item.PaidDate ? moment(item.PaidDate,'DD.MM.YYYY').format('YYYY-MM-DD') : null
            this.levyPayment.PaidOnTime = item.PaidOnTime
            this.levyPayment.InstallmentNumber = item.InstallmentNumber
            this.$showModal('payment')
        },
        pay(){
            this.loading = true
            EmployeeOperationsApi.Levy.Payment.Update(this.levyPayment).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('payment')
                    this.$refs.table.refresh()
                    this.$emit('update')
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${this.value.Employee?.FullName} personeline ait ${item.PaymentDate} tarihli icra ödemesini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    EmployeeOperationsApi.Levy.Payment.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                            this.$emit('update')
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>